<template>
  <v-card>
    <v-card-actions>
      <v-btn color="default" to="/auth/login">
        <v-icon small>{{ mdiArrowLeft }}</v-icon>
        {{ $t('common.back')}}
      </v-btn>
    </v-card-actions>
    <v-card-title primary-title>
      {{ $$t('introduction') }}
    </v-card-title>
    <v-card-text v-html="$$t('intro')" />
    <v-card-title primary-title>
      {{ $$t('application') }}
    </v-card-title>
    <v-card-text v-html="$$t('app')" />
    <v-card-title primary-title>
      {{ $$t('termsOfUse') }}
    </v-card-title>
    <v-card-text v-html="$$t('tou')" />
    <v-card-title primary-title>
      {{ $$t('privacyPolicyChanges') }}
    </v-card-title>
    <v-card-text v-html="$$t('pp')" />
    <v-card-actions>
      <v-btn color="default" to="/auth/login">
        <v-icon small>{{ mdiArrowLeft }}</v-icon>
        {{ $t('common.back')}}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mdiArrowLeft } from '@mdi/js';

export default {
  module: 'Terms',
  name: 'Terms',
  data() {
    return {
      mdiArrowLeft,
    };
  },
};
</script>
